import { MenuProps } from 'antd'
import { useGetMachinesQuery } from '../../../../../store/api/machines-api'
import RewindQueueEntry from '../../../../../types/api/rewind-queue-entry'
import { rewinderMachinesQuery } from '../../constants/query-params'
import { canMoveRewindQueueEntry } from '../../helpers/can-move-rewind-queue-entry'
import useMoveRewindQueueEntries from './use-move-rewind-queue-entries'

type MenuItem = NonNullable<MenuProps['items']>[number]

export default function useMoveToMachineMenuItem(
    entries: RewindQueueEntry[],
    label: string,
    onMoved?: () => void
): MenuItem {
    const { data } = useGetMachinesQuery(rewinderMachinesQuery)
    const { moveToMachine, isLoading } = useMoveRewindQueueEntries()
    const currentMachineDocIds = new Set(entries.map(entry => entry.machine?.documentId))
    const machines = [...(data?.data || [])]
        .filter(machine => !currentMachineDocIds.has(machine.documentId))
        .sort((a, b) => a.name.localeCompare(b.name))

    return {
        key: 'move-to-machine',
        label,
        disabled: isLoading || entries.length === 0 || !entries.every(canMoveRewindQueueEntry),
        children: machines.map(machine => ({
            key: machine.documentId,
            label: machine.name,
            onClick: async () => {
                await moveToMachine(entries, machine)
                onMoved?.()
            },
        })),
    }
}
